import type { MotionProps } from 'framer-motion';

export const getCarouselNavButtonLabelMotionProps = ({
  isActive,
  isInView,
  labelWidth,
}: {
  isActive: boolean;
  isInView: boolean;
  labelWidth: number;
}): MotionProps => ({
  animate: {
    width: isActive && isInView ? labelWidth : 0,
  },
});
